import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()
        this.url = process.env.REACT_APP_KECLOACK_URL
        this.globalUrl = process.env.REACT_APP_BASE_URL
    }

    loginUser(userName, password) {
        let formData = new URLSearchParams()

        formData.append("username", userName)
        formData.append("password", password)

        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET)
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(resolve).catch(reject)

        })

    }

    getAccessInfo(token) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/admins/access-information`,
                {},
                {
                    "Authorization": this.httpClient.convertToken(token),
                    'Content-Type': "application/json"
                }
            ).then(resolve).catch(reject)
        })
    }

    sendVerificationCode(username, password, key) {

        let formData = new URLSearchParams()
        formData.append("username", username)
        formData.append("password", password)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CAPTCHA': key,
                'X-CAPTCHA-CLIENT': "web"
            }
        }

        return new Promise((resolve, reject) => {
            axios.post(
                process.env.REACT_APP_BASE_URL + "admins/two-factors/otp/sms",
                formData,
                config
            ).then(response=>{
                console.log("i send code and response is ",response)
                resolve(response.data)
            }).catch(reject)

        })
    }

    sendOtpSmsForgetPassword(phoneNumber, key) {

        const config = {
            headers: {
                'X-CAPTCHA': key,
                'X-CAPTCHA-CLIENT': "web"
            }
        }


        return new Promise((resolve, reject) => {

            new HttpClient(
                config
            ).post(
                `admins/password/restart/otp/sms`,
                {
                    phoneNumber
                }
            ).then(resolve).catch(reject)

        })
    }

    updateForgotPassword(username, newPassword, phoneNumber, otp) {
        let formData = new URLSearchParams()
        formData.append("phoneNumber", phoneNumber)
        formData.append("newPassword", newPassword)
        formData.append("username", username)
        formData.append("otp", otp)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }

        return new Promise((resolve, reject) => {
            new HttpClient(
                config,
                'application/x-www-form-urlencoded'
            ).post("admins/password/reset", formData
            ).then(resolve).catch(reject)
        })
    }
}